import { StringKey } from 'dictionaries/string-key.enum';
import { SVGAttributes } from 'react';

export interface IconProps {
  stroke?: string;
  width?: number;
  height?: number;
  fill?: string;
  active?: boolean;
  className?: SVGAttributes<SVGSVGElement>['className'];
}

export type TextDirection = 'ltr' | 'rtl';

export type LanguageDictionary = Record<StringKey, string>;

export enum InquiryType {
  GENERAL = 'GENERAL',
  DEMO_REQUEST = 'DEMO_REQUEST',
  TECHNICAL_SUPPORT = 'TECHNICAL_SUPPORT',
  SUBSCRIPTION_AND_PRICING = 'SUBSCRIPTION_AND_PRICING',
  PARTNERSHIP_OPPORTUNITIES = 'PARTNERSHIP_OPPORTUNITIES',
  SPONSORSHIP_DEALS = 'SPONSORSHIP_DEALS',
  VENDOR_REGISTRATION = 'VENDOR_REGISTRATION',
  MEDIA_AND_PR = 'MEDIA_AND_PR',
  EVENT_MANAGEMENT_SERVICES = 'EVENT_MANAGEMENT_SERVICES',
  FEEDBACK_OR_SUGGESTIONS = 'FEEDBACK_O_SUGGESTIONS',
  INVESTOR_RELATIONS = 'INVESTOR_RELATIONS',
  OTHER = 'OTHER',
}

export enum SectorType {
  TECHNOLOGY = 'TECHNOLOGY',
  FINANCE_AND_INVESTMENT = 'FINANCE_AND_INVESTMENT',
  ENVIRONMENTAL = 'ENVIRONMENTAL',
  SOCIAL_AND_CHARITY_IMPACT = 'SOCIAL_AND_CHARITY_IMPACT',
  GOVERNMENT = 'GOVERNMENT',
  SCIENCE_AND_EDUCATION = 'SCIENCE_AND_EDUCATION',
  TRAVEL_AND_TOURISM = 'TRAVEL_AND_TOURISM',
  MEDIA_AND_COMMUNICATIONS = 'MEDIA_AND_COMMUNICATIONS',
  CORPORATE_AND_HUMAN_RESOURCES = 'CORPORATE_AND_HUMAN_RESOURCES',
  HEALTH_AND_WELLNESS = 'HEALTH_AND_WELLNESS',
  SPORTS_AND_RECREATION = 'SPORTS_AND_RECREATION',
  ART_AND_CULTURE = 'ART_AND_CULTURE',
  ENTERTAINMENT_AND_EVENT_MANAGEMENT = 'ENTERTAINMENT_AND_EVENT_MANAGEMENT',
  OTHER = 'OTHER',
}

export enum HeardFrom {
  GEA = 'GEA',
  INCUBATORS_AND_ACCELERATORS = 'INCUBATORS_AND_ACCELERATORS',
  PLUG_AND_PLAY = 'PLUG_AND_PLAY',
  SOCIAL_MEDIA = 'SOCIAL_MEDIA',
  FRIEND_OR_COLLEAGUE = 'FRIEND_OR_COLLEAGUE',
  EVENT_OR_EXHIBITION = 'EVENT_OR_EXHIBITION',
  ONLINE_SEARCH = 'ONLINE_SEARCH',
  OTHER = 'OTHER',
}

export interface EventInvitationResponse {
  eventName: string;
  startDate: Date;
  endDate: Date;
  location?: string;
  ticket: {
    seat?: number;
    row?: number;
    sector?: string;
  };
}

export interface EventResponse {
  name: string;
  startDate: Date;
  location?: string;
  price?: number;
  bannerId?: string;
}
